import { Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import TicketsListItem from './TicketsListItem';

const TicketsListTable = props => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead color="primary">
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Asunto</TableCell>
            <TableCell>Usuario</TableCell>
            <TableCell>Creado en</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tickets?.map(ticket => <TicketsListItem key={ticket._id} {...ticket} />)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TicketsListTable;
